export const faqs = [
  ['Is this a physical product?', 'No. Complete Lumbar Rehabilitation Bundle is a 100% digital product.'],
  [
    'Who is this system designed for?',
    'Physical therapists, physiotherapists, kinesiologists, and qualified rehabilitation professionals.',
  ],
  [
    'Do I need previous professional training?',
    'Yes. This collection is designed for qualified professionals and does not replace clinical education or training.',
  ],
  [
    'Are the exercises explained step by step?',
    'Yes. The exercise volumes include starting positions, execution instructions, sets, repetitions, rest periods, and modification options — covering lumbar mobility, trunk control, resistance training, functional movement, and return-to-activity programming.',
  ],
  [
    'Are complete rehabilitation sessions included?',
    'Yes. The collection contains 48 structured sessions and 12 additional patient-based programming examples.',
  ],
  ['Are all five bonuses included?', 'Yes. All five practical bonuses are included at no additional cost.'],
  ['How will I receive the product?', 'You will receive digital access instructions after your purchase is confirmed.'],
  ['Is this a subscription?', "No. It's a one-time purchase of $26.90 USD."],
  [
    'Does this replace clinical assessment or medical care?',
    'No. The materials are professional educational resources. Exercise selection and treatment decisions must be individualized by qualified professionals.',
  ],
  ['Is there a guarantee?', "Yes. The offer includes a 7-day guarantee, subject to the store's refund policy."],
] as const
